import { Location } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { 
  ActivatedRoute,
  Router,
} from '@angular/router';
import { IonContent,AlertController,ActionSheetController, MenuController,LoadingController, ModalController,AnimationController, Platform } from '@ionic/angular';

import { Storage } from '@ionic/storage-angular';
// import { Storage } from '@ionic/storage';
import { CartService } from 'src/app/services/cart.service';
import { PopupAttributePage } from 'src/app/pages/popup-attribute/popup-attribute.page';
// import { PosPage } from '../../pages/pos/pos.page';
import { DataService } from 'src/app/services/data.service';
import { VariantMappingComponent } from 'src/app/components/add-inventory-management/variant-mapping/variant-mapping.component';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
})
export class ProductListComponent  implements OnInit {
  
  @Input() product_list;
  @Output() submit = new EventEmitter();
  // cat_products:any = [];
  wishcart_items = [];
  cart_len;
  no_products = false;
  page_no = 1;
  choosed_product_name;
  sort = '';
  sort_text;
  drop_down2 = false;
  ids = '';
  category_filters;
  category_child;
  mobile_child;
  // skeleton = true;
  sortby_drop_down = false;
  @ViewChild('dropdown2', { read: ElementRef }) dropdown2:any = ElementRef;
  @ViewChild(IonContent) private content:any = IonContent;
  tableID;
  all_products: any = [];
  searchmenuitems: any = [];
  active;


  // public pos: PosPage,
  constructor(public storage: Storage,public ngcart: CartService, public db: DataService, private router: Router, private route: ActivatedRoute, private modalCtrl: ModalController, private alertCtrl: AlertController, private platform: Platform, private location: Location, private actionSheetCtrl: ActionSheetController,private animationCtrl: AnimationController) {
  }

  ngOnInit() {
    this.no_products = false;
    this.db.choosed_product_id = undefined;
    this.db.ismobile = this.db.checkmobile();

    this.db.skeleton = true;
    this.db.inventory_category = '';
    this.db.inventory_search_txt = '';
    this.db.product_page_no = 1;
    this.db.no_inventory_products = false;
    this.db.cat_products = [];

    this.get_all_category();
    this.db.get_inventory_products();
    this.route.params.subscribe((res:any) => {
      if (res.product && !res.product_1 && !res.product_2) {
        this.db.choosed_product_id = this.route.snapshot.paramMap.get('product'); //for api call
        this.db.childs.child_1 = this.db.choosed_product_id // store child-1
        this.db.childs.child_2 = undefined
        this.db.childs.child_3 = undefined
        this.db.childs.child_2_name = undefined
        this.db.childs.child_3_name = undefined
      } else if (res.product && res.product_1 && !res.product_2) {
        this.db.choosed_product_id = this.route.snapshot.paramMap.get('product_1');
        this.db.childs.child_2 = this.db.choosed_product_id
        this.db.childs.child_1 = res.product
        this.db.childs.child_3 = undefined
        this.db.childs.child_3_name = undefined
      } else if (res.product && res.product_1 && res.product_2) {
        this.db.choosed_product_id = this.route.snapshot.paramMap.get('product_2');
        this.db.childs.child_3 = this.db.choosed_product_id
        this.db.childs.child_1 = res.product
        this.db.childs.child_2 = res.product_1
      }
    })
    this.db.choosed_brands = [];
    this.db.choosed_attributes = [];
  }

  @HostListener('window:resize', ['$event'])
  private func() {
    this.db.ismobile = this.db.checkmobile();
  }
  
  ionViewWillEnter() {
    this.content.scrollToTop();
  }

  smoothscroll() {
    let check = document.getElementById("content") as HTMLInputElement
    check.scrollIntoView({ behavior: 'smooth' });
  }


  loadData(event) {

    let value = event.target.offsetHeight + event.target.scrollTop + 1;
    value = value.toFixed() ;

    if(value >= event.target.scrollHeight){

      if(!this.db.no_inventory_products){
        this.db.product_page_no = this.db.product_page_no + 1;
        this.db.get_inventory_products();
      }
      
    }

    // if(event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight){
    //   if(!this.db.no_inventory_products){
    //     this.db.product_page_no = this.db.product_page_no + 1;
    //     this.db.get_inventory_products();
    //   }
    // }
  }


  get_cat_products(sort) {
    this.db.product_page_no = 1;
    this.db.no_inventory_products = false;
    this.db.inventory_category = this.db.choosed_product_id;
    this.db.get_inventory_products();
  }

  added_product_list(select_item,index){
  //  let obj = { 'product_id':select_item.name,'attribute_id':select_item.attribute_id};
      this.active_dropdwon = index
      if(select_item.variants && select_item.variants.length == 0){
       if(this.db.inventory_items.length == 0){
        select_item['Added_to_inventory'] = 1;
        this.db.inventory_items.push(select_item);
        
        }else {
          // if(!select_item['Added_to_inventory'])
          select_item['Added_to_inventory'] = !select_item['Added_to_inventory'] ? 1 : 0;
          if(select_item['Added_to_inventory'] == 1){
            this.db.inventory_items.push(select_item)
          }else{
            let find_index = this.db.inventory_items.findIndex(r=> r.name == select_item.name)
            if(find_index >= 0){
              this.db.inventory_items.splice(find_index,1);
            }
          }
        }
        this.storage.set('inventroy_items', this.db.inventory_items);

        if(select_item['Added_to_inventory'] == 1){
          let last_count = this.db.inventory_items.length - 1;
          this.db.added_animate.next({'item': this.db.inventory_items[last_count].item, 'images':this.db.inventory_items[last_count].product_image, 'add_to_cart':1 })
        }
        
      }else{
         this.open_variants_pop_up(select_item)
      }
  }



  async open_variants_pop_up(select_item) {
 
    const modal = await this.modalCtrl.create({   
      component: VariantMappingComponent,
      cssClass: 'variant-mapping-popup',
      componentProps:{
        product_values:select_item
      },
      enterAnimation: this.enterAnimation ,
      leaveAnimation: this.leaveAnimation,
     })
     await modal.present();

     const { data } = await modal.onWillDismiss();
      if (data && data.status && data.status == 'success') {
        // console.log(data);
      }
  } 

  // ion-model slide left transaction
  enterAnimation = (baseEl: HTMLElement) => { 
    var root:any = baseEl.shadowRoot;
    const backdropAnimation = this.animationCtrl
      .create()
      .addElement(root.querySelector('ion-backdrop')!)
      .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

    const wrapperAnimation = this.animationCtrl
      .create()
      .addElement(root.querySelector('.modal-wrapper')!)
      .keyframes([
        this.db.ismobile ? { offset: 0, opacity: '0.09', transform: 'translateY(100%)' } : { offset: 0, opacity: '0.09', transform: 'translateX(100%)' },
        this.db.ismobile ? { offset: 1, opacity: '1', transform: 'translateY(0)' } : { offset: 1, opacity: '1', transform: 'translateX(0)' },
      ]);
    return this.animationCtrl
      .create()
      .addElement(baseEl)
      .easing('ease-out')
      .duration(500)
      .addAnimation([backdropAnimation, wrapperAnimation]);
  };

  leaveAnimation = (baseEl: HTMLElement) => {
    return this.enterAnimation(baseEl).direction('reverse');
  };


  get_all_category(){
    var data = {
      domain: this.db.domain,
      show_count:1,
      business:localStorage['business']
    }
    this.db.product_category(data).subscribe((data:any) => {
      this.db.category = data.message;

      // this.storage.set('category_list', data.message)
      // localStorage['__LastCategorySyncedDate'] = new Date();
      // this.db.category.find((res:any) => {
      //   if (!this.db.childs.child_1_name) {
      //     if (res.name == this.db.childs.child_1) {
      //       this.db.childs.child_1_name = res.category_name
      //     }
      //     if (!this.db.childs.child_2_name) {
      //       res.child.find(childs => {
      //         if (childs.name == this.db.childs.child_2) {
      //           this.db.childs.child_2_name = childs.category_name
      //         }
      //         if (!this.db.childs.child_3_name) {
      //           childs.child.find(sub_child => {
      //             if (sub_child.name == this.db.childs.child_3) {
      //               this.db.childs.child_3_name = sub_child.category_name;
      //             }
      //           })
      //         }
      //       })
      //     }
      //   }
      // })
      // this.get_mobile_childs();
    }, error => { console.log(JSON.stringify(error.json())); });
  }



  // category_products() {
  //   if (this.all_products.length != 0) {
  //     if (this.db.choosed_product_id == 'All') {
  //       this.cat_products = this.all_products;
  //     }
  //     else{
  //       // this.cat_products = this.all_products.filter(obj => obj.category == this.db.choosed_product_id);
  //       var all_data:any =[];
  //       this.all_products.map(res=>{
  //         res.category_mapping.map(value =>{
  //           if(value.category == this.db.choosed_product_id)
  //             // all_data = [...all_data,...res]
  //              all_data.push(res)
  //         })
  //       })
  //       this.cat_products = all_data;
  //       // console.log(all_data.length)
  //     }

  //     if (this.cat_products.length == 0)
  //       this.no_products = true
  //     // this.get_cart_item();
  //   }
  //   else {
  //     this.storage.get('selectmenu').then((val) => {
  //       if (!val || val.length == 0) {
  //         setTimeout(() => { this.skeleton = false; }, 8000);
  //         this.db.get_all_products().subscribe((data: any) => {
  //           this.all_products = data.message;
  //           this.storage.set('selectmenu', data.message)
  //           this.category_products();
  //         }, error => { console.log(JSON.stringify(error.json())); });
  //       }
  //       else{
  //         setTimeout(() => { this.skeleton = false; }, 10);
  //         this.all_products = val;
  //         this.category_products();
  //       }
  //     });
  //   }
  // }

  active_dropdwon:any = 0;
  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event) { 
    // console.log(event)
    if(this.db.cat_products && this.db.cat_products.length != 0){
      if(event.key == 'ArrowDown'){ 
        (this.db.cat_products.length - 1 ) >  this.active_dropdwon ?  this.active_dropdwon += 1 : null
        // 
      } else if(event.key == 'ArrowUp') {
        this.active_dropdwon != 0 ?  this.active_dropdwon -= 1 : null
        // this.searching_down.nativeElement.scrollIntoView({behavior: "smooth", block: "start",inline: "nearest"});
      }else if( event.key == 'Enter'){
        let item = this.db.cat_products[this.active_dropdwon];
        this.added_product_list(item,this.active_dropdwon)
      }
      let check = document.getElementById(this.active_dropdwon +'s') as HTMLInputElement;
      check.scrollIntoView({ behavior: "smooth", block: "start",  inline: "nearest" });
    }
  } 



  arrow_down_fn(current_active) {
    let cur_active = this.active;
      if (this.db.cat_products && this.db.cat_products.length != 0) {
        this.active = cur_active + 1;
        let check = document.getElementById(this.active + '_scroll') as HTMLInputElement
        check.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
      }
    // }
  }

  arrow_up_fn(current_active) {
    let cur_active = this.active;
    // if (this.pos.current_active == 'search') {
      if ((cur_active - 1) < this.searchmenuitems.length && (cur_active - 1) != -1) {
        this.active = cur_active - 1;
        let check = document.getElementById(this.active + '_scroll') as HTMLInputElement
        check.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });

      // }
    }
  }

  shortcuts(event) {
    if (event.keyCode == 13) {
      event.preventDefault(); // prevent default function of Enter
    }
  }

  // get_category() {
  //   if (this.db.category.length == 0) {
  //     this.storage.get('category_list').then((val) => {
  //       if (!val || val.length == 0) {
  //         this.get_all_category();
  //       }
  //       else {
  //         this.db.category = val;
  //         this.db.category.find((res:any) => {
  //           if (!this.db.childs.child_1_name) {
  //             if (res.name == this.db.childs.child_1) {
  //               this.db.childs.child_1_name = res.category_name
  //             }
  //             if (!this.db.childs.child_2_name) {
  //               res.child.find(childs => {
  //                 if (childs.name == this.db.childs.child_2) {
  //                   this.db.childs.child_2_name = childs.category_name
  //                 }
  //                 if (!this.db.childs.child_3_name) {
  //                   childs.child.find(sub_child => {
  //                     if (sub_child.name == this.db.childs.child_3) {
  //                       this.db.childs.child_3_name = sub_child.category_name;
  //                     }
  //                   })
  //                 }
  //               })
  //             }
  //           }
  //         })
  //         this.get_mobile_childs();
  //       }
  //     });

  //   } else {
  //     this.get_mobile_childs();
  //   }
  // }

  // get_all_category(){
  //   var data = {
  //     domain: this.db.domain,
  //     show_count:1,
  //     business:localStorage['business']
  //   }
  //   this.db.product_category(data).subscribe((data:any) => {
  //     this.db.category = data.message;
  //     this.storage.set('category_list', data.message)
  //     localStorage['__LastCategorySyncedDate'] = new Date();
  //     this.db.category.find((res:any) => {
  //       if (!this.db.childs.child_1_name) {
  //         if (res.name == this.db.childs.child_1) {
  //           this.db.childs.child_1_name = res.category_name
  //         }
  //         if (!this.db.childs.child_2_name) {
  //           res.child.find(childs => {
  //             if (childs.name == this.db.childs.child_2) {
  //               this.db.childs.child_2_name = childs.category_name
  //             }
  //             if (!this.db.childs.child_3_name) {
  //               childs.child.find(sub_child => {
  //                 if (sub_child.name == this.db.childs.child_3) {
  //                   this.db.childs.child_3_name = sub_child.category_name;
  //                 }
  //               })
  //             }
  //           })
  //         }
  //       }
  //     })
  //     this.get_mobile_childs();
  //   }, error => { console.log(JSON.stringify(error.json())); });
  // }

  // get_mobile_childs() {
  //   if (this.db.childs.child_2) {
  //     this.db.category.map((res:any) => {
  //       if (res.name == this.db.childs.child_1) {
  //         this.category_child = res //selected main category
  //       }
  //       res.child.map(child => {
  //         if (child.name == this.db.childs.child_2) {
  //           this.mobile_child = child //selected sub category
  //         }
  //       })
  //     })
  //   }
  // }

  // menu_search() {
  //   // if (this.pos.queryText != undefined && this.pos.queryText != null && this.pos.queryText != "") {
  //     // this.searchmenuitems = this.filterItems(this.pos.queryText);
  //     this.cat_products = this.searchmenuitems;
  //     // this.pos.current_active = 'search';
  //     this.active = 0;
  //     this.db.sub.next('cart emitted');
  //     this.get_recommeded();
  //   // }
  //   // else {
  //   //   this.searchmenuitems = [];
  //   //   this.category_products()
  //   //   // this.pos.current_active = '';
  //   //   this.active = -1;
  //   //   this.db.sub.next('cart emitted');
  //   //   this.get_recommeded();
  //   // }
  // }

  // filterItems(searchTerm) {
  //   return this.all_products.filter(obj => (obj.item.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1) || (obj.sku ? obj.sku.indexOf(searchTerm.toLowerCase()) > -1 : ''))
  //   // return this.all_products.filter((item) => {
  //   //   return item.item.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
  //   // });
  // }

  // db_check(attributes, attribute) {
  //   this.category_filters.attribute_list.map(value => {
  //     if (attributes == value.attribute_unique_name) {
  //       value.options.map(res => {
  //         if ((attribute.split(',')).includes(res.unique_name)) {
  //           res.choosed = 1
  //         } else {
  //           res.choosed = 0
  //         }
  //       })
  //     }
  //   })
  // }

  // clearall() {
  //   this.db.choosed_brands = [];
  //   this.db.choosed_attributes = [];
  //   this.db.rating = ''
  //   this.router.navigate([location.pathname]);
  // }


  // goroute() {
  //   if (this.db.choosed_brands.length != 0) {
  //     this.router.navigate([location.pathname], { queryParams: { f: this.db.choosed_brands.toString() } });
  //   } else 
  //     this.router.navigate([location.pathname]);
  // }


  // get_category_page_filters(value) {
  //   let data = { category: value }
  //   this.db.get_category_page_filters(data).subscribe((res:any) => {
  //     this.category_filters = res.message;
  //     this.db.choosed_attributes.find((res:any) => {
  //       this.db_check(res.attribute, res.value)
  //     })
  //   })
  // }

  // get_recommeded() {
  //   this.cat_products.find(res => {
  //     res.count = this.checkcart(res.name)
  //     // res.iswish = this.checkWishCart(res.name)
  //   })
  // }

  // checkcart(id) {
  //   var cnt = 0;
  //   if (this.db.isNgCart == true)
  //     this.db.cart_items.find(res => { if (res.id == id && res.is_free_item != 1) { cnt += res.quantity } })
  //   else
  //     this.db.cart_items.find(res => { if (res.product == id && res.is_free_item != 1) { cnt += res.quantity } })
  //   return cnt;
  // }

  // checkWishCart(id) {
  //   var cnt = 0;
  //   if (this.db.isNgCart == true)
  //     this.wishcart_items.find(res => { if (res.id == id) { cnt += res.quantity } })
  //   else
  //     this.wishcart_items.find(res => { if (res.product == id) { cnt += res.quantity } })
  //   return cnt;
  // }


  // get_cart_item() {
  //   if (this.db.isNgCart == true) {
  //     this.db.cart_items = this.ngcart.TableCartItems('')
  //     this.db.cart_count = this.ngcart.getTableCartLength('')
  //     this.db.sub_total = this.ngcart.getTableCartTotal('')
  //     this.db.sub.next('cart emitted');
  //     this.get_recommeded();
  //   }
  //   else {
  //     if (localStorage['customerRefId'] != undefined) {
  //       var ddatas = {
  //         customer: localStorage['customerRefId'],
  //         user: ""
  //       }
  //       this.db.get_cart_items(ddatas).subscribe(data => {
  //         this.cart_len = 0;
  //         if (data.message.cart && data.message.cart != null && data.message.cart.items.length != 0) {
  //           this.db.cart_items = data.message.cart.items;
  //           this.cart_len = data.message.cart.items.length;
  //           this.db.cart_count = data.message.cart.items.length;
  //         } else {
  //           this.db.cart_items = [];
  //           this.db.cart_count = undefined;
  //         }

  //         if (data.message.wishlist && data.message.wishlist != null && data.message.wishlist.items.length != 0) {
  //           this.wishcart_items = data.message.wishlist.items;
  //           this.db.wish_count = data.message.wishlist.items.length;
  //         } else {
  //           this.wishcart_items = [];
  //           this.db.wish_count = undefined;
  //         }
  //         this.get_recommeded();
  //       }, error => { console.log(JSON.stringify(error.json())); });
  //     } else {
  //       this.get_recommeded();
  //     }
  //   }
  // }

  // async addtocart(value) {
  //   if (this.db.isNgCart == true) {
  //     if (value.ids == undefined) {
  //       value.ids = '';
  //       value.selected_attribute = ''
  //     }
  //     if (value.product_attributes.length == 0) {
  //       value.quantity = value.cart_count
  //       value.id = value.name;
  //       value.title = value.item;
  //       if (value.discount_price) {
  //         value.minprice = value.discount_price;
  //         value.prices = value.discount_price;
  //       }
  //       else {
  //         value.minprice = value.price;
  //         value.prices = value.price;
  //       }
  //       this.ngcart.addItem(value, value.cart_count, value, '', '', '', '')
  //       this.db.cart_items = this.ngcart.TableCartItems('')
  //       this.db.cart_count = this.ngcart.getTableCartLength('')
  //       this.db.sub_total = this.ngcart.getTableCartTotal('')
  //       this.db.sub.next('cart emitted');
  //       this.get_recommeded()
  //     } else {
  //       const modal = await this.modalCtrl.create({
  //         component: PopupAttributePage,
  //         cssClass: 'attribute-popup',
  //         componentProps: { product_info: value }
  //       })
  //       modal.present()
  //       let { data } = await modal.onWillDismiss();
  //       if (data == 'success') {
  //         this.db.sub.next('cart emitted');
  //         this.get_recommeded()
  //       }
  //     }
  //   }
  //   else {
  //     if (value.ids == undefined) {
  //       value.ids = '';
  //       value.selected_attribute = ''
  //     }
  //     if (value.product_attributes.length == 0) {
  //       var datas = {
  //         item_code: value.name,
  //         qty: value.cart_count,
  //         qty_type: "",
  //         rate: value.price,
  //         cartType: "Shopping Cart",
  //         customer: localStorage['customerRefId'],
  //         attribute: value.selected_attribute,
  //         attribute_id: value.ids
  //       }
  //       this.db.insert_cart_items(datas).subscribe(data => {
  //         if (data.message.status == "failed") {
  //           this.db.alert(data.message.message)
  //         } else {
  //           if (localStorage['customerRefId'] == undefined) {
  //             localStorage['customerRefId'] = data.message.customer
  //             localStorage['guestRefId'] = data.message.customer
  //           }
  //           this.get_cart_item()
  //         }

  //       }, error => { console.log(JSON.stringify(error.json())); });
  //     } else {
  //       console.log(value.product_attributes);
  //       const modal = await this.modalCtrl.create({
  //         component: PopupAttributePage,
  //         cssClass: 'attribute-popup',
  //         componentProps: { attributes: value }
  //       })
  //       modal.present()
  //     }
  //   }
  // }

  //Remove Cart
  // async removetocart(value) {
  //   if (value.product_attributes.length == 0) {
  //     this.db.cart_items.find(res => {
  //       if (res.product == value.name) {
  //         value.selected_cart_id = res.name
  //       }
  //     })
  //   }
  //   if (value.cart_count == 0) {
  //     var datass = {
  //       name: value.selected_cart_id,
  //       customer: localStorage['customerRefId'],
  //       user: ""
  //     }
  //     this.db.delete_cart_items(datass).subscribe(data => {
  //       this.get_cart_item();
  //     }, error => { console.log(JSON.stringify(error.json())); });
  //   } else {
  //     var datas = {
  //       name: value.selected_cart_id,
  //       qty: value.cart_count,
  //       qty_type: ""
  //     }
  //     this.db.update_cart_items(datas).subscribe(data => {
  //       this.get_cart_item();
  //     }, error => { console.log(JSON.stringify(error.json())); });
  //   }
  // }

  // add_cart(data, count) {
  //   data.cart_count = count;
  //   this.addtocart(data)
  // }

  // remove_cart(data, count) {
  //   data.cart_count = count;
  //   if (this.db.isNgCart == true) {
  //     data.count = count
  //     this.ngcart.removeoneItemById(data.name, '', '')
  //     this.db.cart_items = this.ngcart.TableCartItems('')
  //     this.get_recommeded();
  //     this.db.sub.next('cart emitted');
  //   }
  //   else
  //     this.removetocart(data)
  // }

  // remove_wish(data, count) {
  //   data.wish_count = count;
  // }

  // add_wish(data, count) {
  //   data.wish_count = count;
  //   // this.addtowish(data);
  // }


}
